import styles from '../styles.scss';
import { SiteModeNavigationBlock } from 'models/SiteModeNavigationBlock';
import { Header, Item } from 'components/Navigation';
import { selectSiteMode } from 'components/Header/themes/BGH/selector';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { SiteMode as SiteModeEnum } from 'models/SiteMode';
import { rm } from 'utils';
import { setSiteMode } from 'store/appShell/actions';
import { Button } from 'components/Button';

interface SelectedProps {
  title: string;
  siteMode: SiteModeEnum;
}

const itemSelected = ({ title, siteMode }: SelectedProps) => {
  if (
    title === rm('checkout_folder_private') &&
    (siteMode === SiteModeEnum.Private || siteMode === SiteModeEnum.Unknown)
  ) {
    return true;
  }

  if (title === rm('checkout_folder_company') && siteMode === SiteModeEnum.Company) {
    return true;
  }

  return false;
};

export const SiteModeBlock = ({ header, items }: SiteModeNavigationBlock) => {
  const siteMode = useSelector(selectSiteMode);
  const dispatch = useDispatch();

  const changeSiteMode = (title: string) => () => {
    const sm =
      title === rm('checkout_folder_private') ? SiteModeEnum.Private : SiteModeEnum.Company;
    return dispatch(setSiteMode(sm));
  };

  return (
    <div className={styles.siteMode}>
      <Header className={styles.header} invert>
        {header}
      </Header>
      {items.map(item => (
        <Item key={item.title}>
          <Header className={styles.header}>
            <Button
              onClick={changeSiteMode(item.title)}
              appearance="link"
              className={cn(styles.siteModeType, {
                [styles.siteModeSelected]: itemSelected({ title: item.title, siteMode })
              })}
            >
              {item.title}
            </Button>
          </Header>
        </Item>
      ))}
    </div>
  );
};
